import { render, staticRenderFns } from "./DomainDnssecStatus.vue?vue&type=template&id=fd7591e4&"
import script from "./DomainDnssecStatus.vue?vue&type=script&lang=js&"
export * from "./DomainDnssecStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports